import React from 'react';
import { getIcons } from '../../Constant/Constant';

const IntegrationModel = ({ openModel, closeModel, seletedMedia }) => {
  const Icons = getIcons();

  if (!openModel) return null;

  
  const mediaData = {
    "Facebook ADS": {
      title: "Facebook Integration",
      description: "Integrate your Facebook leads, instantly actionable in GL Funnel CRM.",
      instruction: "Tap to ‘Login with Facebook’ and select the Facebook Pages you want to receive leads from.",
      buttonText: "Connect FB Account",
      icon: Icons.faceBookIcon,
    },
    "Google ADS": {
      title: "Google Ads Integration",
      description: "Integrate your Google Ads leads with GL Funnel CRM for instant follow-up.",
      instruction: "Click to sign in with Google and select the campaigns you want to integrate.",
      buttonText: "Connect Google Account",
      icon: Icons.googleIcon,
    },
    "Zapier ADS": {
      title: "Zapier Integration",
      description: "Connect your lead data from various apps using Zapier to GL Funnel CRM.",
      instruction: "Click to authorize Zapier and set up your Zaps for automatic lead transfer.",
      buttonText: "Connect Zapier",
      icon: Icons.ZapierIcon,
    },
  };

  const selectedData = mediaData[seletedMedia] || {};

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white flex flex-col gap-6 rounded-lg p-6 w-full max-w-2xl relative">
        <div className="flex items-center justify-between bg-slate-100 px-3 py-4 rounded-md">
          <div className="text-lg font-medium text-customGreen">
            {selectedData.title}
          </div>
          <button
            onClick={closeModel}
            className="text-2xl bg-white rounded-full w-10 h-10 text-red-500"
          >
            &times;
          </button>
        </div>

        <div className="flex flex-col items-center justify-center gap-4 text-center">
          <img src={Icons.IntegrationIcon} className="w-60" alt="Integration Graphic" />
          <h2 className="font-semibold">{selectedData.description}</h2>
          <p className="text-sm px-10 text-gray-600">{selectedData.instruction}</p>

          <button className="flex items-center mt-4 gap-3 bg-blue-500 rounded-lg px-4 py-2 text-white font-medium hover:bg-blue-600 transition">
            <img src={selectedData.icon} className="w-5 h-5" alt={`${seletedMedia} Icon`} />
            {selectedData.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntegrationModel;
